export const ciReportingEn = {};

export const ciReportingFr = {};
